import type { MoneyCents } from '../core/types';
import type { SpinPresentationResult } from '../rendering/types';
import type { ReplayDraftV2 } from '../replay/schema';

export const EXTREME_PAID_SPINS = 250;
export const EXTREME_BET_CENTS = 200;
export const EXTREME_START_BALANCE_CENTS = EXTREME_PAID_SPINS * EXTREME_BET_CENTS;

export interface ExtremeBaseStepV1 {
  readonly kind: 'base';
  readonly paidSpin: number;
  readonly balanceAfterCents: MoneyCents;
  readonly featureTriggered: boolean;
  readonly presentation: SpinPresentationResult;
}

export interface ExtremeFeatureDraftV1 {
  readonly featureIndex: number;
  readonly triggerPaidSpin: number;
  readonly replayDraft: ReplayDraftV2;
}

export interface ExtremeRunStateV1 {
  readonly version: 1;
  readonly id: string;
  readonly active: true;
  readonly name: string;
  readonly betCents: typeof EXTREME_BET_CENTS;
  readonly startBalanceCents: typeof EXTREME_START_BALANCE_CENTS;
  readonly returnBalanceCents: MoneyCents;
  readonly returnBetCents: MoneyCents;
  readonly startedAt: number;
  readonly paidSpinsCompleted: number;
  readonly featureCount: number;
  readonly baseSteps: readonly ExtremeBaseStepV1[];
  readonly completedFeatures: readonly ExtremeFeatureDraftV1[];
}

export interface ExtremeRunView {
  readonly id: string;
  readonly username: string;
  readonly betCents: typeof EXTREME_BET_CENTS;
  readonly startBalanceCents: typeof EXTREME_START_BALANCE_CENTS;
  readonly startedAt: number;
  readonly paidSpinsCompleted: number;
  readonly paidSpinsRemaining: number;
  readonly featureCount: number;
  readonly currentX: number;
  readonly readyToComplete: boolean;
}

export interface CompletedExtremeRun {
  readonly id: string;
  readonly username: string;
  readonly betCents: typeof EXTREME_BET_CENTS;
  readonly startBalanceCents: typeof EXTREME_START_BALANCE_CENTS;
  readonly finalBalanceCents: MoneyCents;
  readonly startedAt: number;
  readonly completedAt: number;
  readonly paidSpinsCompleted: typeof EXTREME_PAID_SPINS;
  readonly featureCount: number;
  readonly featureDrafts: readonly ExtremeFeatureDraftV1[];
}

export interface ExtremeRunLeaderboardEntry {
  readonly id: string;
  readonly name: string;
  readonly scoreX: number;
  readonly finalBalanceCents: MoneyCents;
  readonly featureCount: number;
  readonly createdAt: number;
  readonly replayAvailable: false;
  readonly ownerUid?: string;
}

export interface ExtremeFeatureLeaderboardEntry {
  readonly id: string;
  readonly runId: string;
  readonly name: string;
  readonly xValue: number;
  readonly winCents: MoneyCents;
  readonly totalSpins: number;
  readonly createdAt: number;
  readonly replayAvailable: true;
  readonly ownerUid?: string;
}
